import type { PermissionResponse } from '../../services/api/types.gen';

/**
 * Returns true if a permission matches a search query across name, slug, or description.
 */
export function matchesPermissionSearch(
  perm: PermissionResponse,
  query: string
): boolean {
  if (!query) return true;
  const q = query.toLowerCase();
  return (
    perm.name.toLowerCase().includes(q) ||
    perm.slug.toLowerCase().includes(q) ||
    Boolean(perm.description && perm.description.toLowerCase().includes(q))
  );
}
